import axios from 'axios';

import axiosInstance from '../../services/axios';

import { rejectError, checkTokenValidity } from '../../helpers';

import Vue from 'vue';

import LocalStorageService from '../../services/storage/localStorageService';

import { getAPIEndpoint } from '../../helpers';

const localStorageService = LocalStorageService.getService();

export default {
  namespaced: true,
  state: {
    user: null,
    isAuthResolved: false
  },
  getters: {
    authUser(state) {
      return state.user || null;
    },
    isAuthenticated(state) {
      return !!state.user;
      // This is return true or false depending on user if user is null this will return false
    }
  },
  actions: {
    loginWithEmailAndPassword({ commit }, userData) {
      // console.log(userData);

      return axios
        .post(`${getAPIEndpoint()}/auth/login`, userData)
        .then(res => {
          const user = res.data;

          localStorage.setItem('cafe_jwt', user.token);
          localStorage.setItem('refreshToken', user.refreshToken);
          localStorage.setItem('role', user.data.user.role);

          commit('setAuthUser', user.data.user);
        })
        .catch(err => rejectError(err));

      // return axios.post('')
    },

    resetPassword({ commit }, formData) {
      return axios
        .post(`${getAPIEndpoint()}/auth/forgotPassword`, formData)
        .then(res => {})
        .catch(err => rejectError(err));
    },

    submitResetPassword({ commit }, { formData, resetToken }) {
      // debugger;
      return axios
        .patch(`${getAPIEndpoint()}/auth/resetPassword/${resetToken}`, formData)
        .then(() => {})
        .catch(err => rejectError(err));
    },

    getAuthUser({ commit, getters }) {
      const authUser = getters['authUser'];

      const token = localStorage.getItem('cafe_jwt');

      const isTokenValid = checkTokenValidity(token);

      if (authUser && isTokenValid) {
        return Promise.resolve(authUser);
      }

      const config = {
        headers: {
          'Cache-Control': 'no-cache'
        }
      };

      return axiosInstance
        .get(`${getAPIEndpoint()}/auth/me`, config)
        .then(res => {
          const user = res.data.data;
          commit('setAuthUser', user);
          commit('setAuthState', true);
          return user;
        })
        .catch(err => {
          commit('setAuthUser', null);
          commit('setAuthState', false);

          return err;
        });
    },
    updateAuthUser({ commit, state }, formData) {
      return axiosInstance
        .patch(`${getAPIEndpoint()}/auth/updateMe`, formData)
        .then(res => {
          const updatedAuthUser = res.data.data.user;
          commit('setAuthUser', updatedAuthUser);
          return updatedAuthUser;
        });
    },

    updateAuthPassword({ commit, state }, formData) {
      return axiosInstance
        .patch(`${getAPIEndpoint()}/auth/updateMyPassword`, formData)
        .then(res => {
          const updatedAuthPass = res.data.data.user;

          // debugger;

          localStorage.setItem('cafe_jwt', res.data.token);
          // localStorage.setItem('refreshToken', updatedAuthPass.refreshToken);
          commit('setAuthUser', updatedAuthPass);
          return updatedAuthPass;
        });
    },
    logout({ commit }) {
      return new Promise((resolve, reject) => {
        const refreshToken = localStorageService.getRefreshToken();

        axiosInstance
          .delete(`${getAPIEndpoint()}/auth/logout`, {
            data: {
              refreshToken: refreshToken
            }
          })
          .then(() => {
            localStorage.removeItem('cafe_jwt');
            localStorage.removeItem('refreshToken');
            commit('setAuthUser', null);

            resolve(true);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  mutations: {
    setAuthUser(state, user) {
      return (state.user = user);
    },
    setAuthState(state, authState) {
      return (state.isAuthResolved = authState);
    }
  }
};
